import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import home from './modules/home';
import images from './modules/images';
import privacy from './modules/privacy';

export default new Router({
  mode: 'history',
  routes: [...home, ...images, ...privacy],
  strict: process.env.NODE_ENV !== 'production',
})



// WEBPACK FOOTER //
// ./src/vue/router/index.js